export const TAG_KEY = 'old_browser_message';
export const BROWSERS_LIST = ['edge', 'firefox', 'ie', 'safari', 'chrome'];
